<template>
  <v-container fluid>
    <material-card color="green" :title="endpointID ? 'Edit System End Point' : 'Create System End Point'" inline icon="mdi-mail">
      <v-card-actions></v-card-actions>
      <v-card flat class="px-2">
      <form @submit.prevent="save" >
        <v-row>
          <v-col cols="12" lg="4" md="6">
            <span class="body-2 font-weight-medium">System End Point <span class="error--text">*</span></span>
            <v-text-field placeholder="System End Point Name" class="my-0 py-1" v-model.trim="endpoint.name" single-line :counter="100" required name="name"> </v-text-field>
          </v-col>
          <v-col cols="12" lg="4" md="6">
            <span class="body-2 font-weight-medium"> Method <span class="error--text">*</span></span>
            <v-autocomplete name="method" key="methods" class="my-0 py-1" single-line label="---Select---" :items="methods" v-model="endpoint.method" required item-text="methods" item-value="methods">
            </v-autocomplete>
          </v-col>
          <v-col cols="12" lg="4" md="6">
            <span class="body-2 font-weight-medium"> Module <span class="error--text">*</span></span>
            <v-text-field placeholder="Module Name" name="module" maxlength="50" class="my-0 py-1" single-line v-model.trim="endpoint.module" maxlen :counter="50" required> </v-text-field>
          </v-col>
          <v-col cols="12">
            <span class="body-2 font-weight-medium">Description</span>
            <v-textarea placeholder="Write a description" clearable clear-icon="mdi-close-circle" v-model="endpoint.description" rows="4"> </v-textarea>
          </v-col>
          <v-col cols="12">
            <v-card-actions class="d-flex justify-end">
              <v-btn elevation="1" type="submit" color="primary" :class="{ 'is-loading': lock }" :disabled="lock">
                <v-icon left> mdi-content-save </v-icon>
                Save
              </v-btn>
            </v-card-actions>
          </v-col>
        </v-row>
      </form>
      </v-card>
    </material-card>
    <loading-icon :value="isLoading" />
  </v-container>
</template>
<script>
import CONSTANTS from '@/utils/constants'
import MaterialCard from '@/components/template/MaterialCard'

export default {
  components: { MaterialCard },
  name: 'CreateSySEndPoint',
  props: ['endpointID'],
  data: function () {
    return {
      endpoint: {},
      lock: false,
      methods: ['GET', 'PUT', 'POST', 'DELETE'],
      loadingComponent: null,
      isLoading: false
    }
  },
  created: function () {
    if (this.endpointID) {
      this.isLoading = true
      return http
        .get(`${CONSTANTS.API_URL}/api/systemendpoint/${this.endpointID}`)
        .then(endpoint => {
          this.endpoint = endpoint.data
          this.isLoading = false
        })
        .catch(httpException => {
          console.log('Error While Updating System Endpoint', httpException)
          this.isLoading = false

          return this.$dialog.error({
            title: 'Error',
            text: 'Error While Updating System Endpoint'
          })
        })
    }
  },
  methods: {
    loadSystemEndpoint: function (id) {
      if (id) {
        this.isLoading = true

        return http
          .get(`${CONSTANTS.API_URL}/api/systemendpoint/${this.id}`)
          .then(endpoint => {
            this.endpoint = this.endpoint.data
            this.isLoading = false
          })
          .catch(httpException => {
            console.log('Error While Updating System Endpoint', httpException)
            this.isLoading = false

            return this.$dialog.error({
              title: 'Error',
              text: 'Error While Updating System Endpoint'
            })
          })
      }
    },
    save: function () {
      if (this.lock) {
        return
      }
      this.isLoading = true

      this.lock = true
      if (this.endpoint.id) {
        return http
          .put(`${CONSTANTS.API_URL}/api/systemendpoint/${this.endpoint.id}`, this.endpoint)
          .then(() => {
            this.lock = false
            this.isLoading = false

            this.$router.push({
              name: 'SystemEndPointsList'
            })
            return this.$dialog.info({
              title: 'Success',
              text: 'System End Point Updated successfully!'
            })
          })
          .catch(httpException => {
            console.log('Error While Updating System Endpoint', httpException)
            this.isLoading = false

            return this.$dialog.error({
              title: 'Error',
              text: 'Error While Updating System Endpoint'
            })
          })
      }
      return http
        .post(`${CONSTANTS.API_URL}/api/systemendpoint`, this.endpoint)
        .then(() => {
          this.isLoading = false

          this.$router.push({
            name: 'SystemEndPointsList'
          })
          return this.$dialog.info({
            title: 'Success',
            text: 'System End Point Created successfully!'
          })
        })
        .catch(httpException => {
          this.isLoading = false

          console.log('Error While Saving Admin User', httpException)
          this.lock = false
        })
    }
  }
}
</script>
